import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core';
import { ContactService } from './../../services/contact.service';
import { TeamContact } from './../../models/TeamContact';
import { Router, ActivatedRoute } from '@angular/router';
import { ContactDetails } from './../../models/ContactDetails';
import { Contact } from './../../models/Contact';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-yourjssiteam',
  templateUrl: './yourjssiteam.component.html',
  styleUrls: ['./yourjssiteam.component.scss']
})
export class YourjssiteamComponent implements OnInit, OnChanges, OnDestroy {
  public yourJssiTeam: TeamContact;
  public yourContactsTempModel: ContactDetails;
  public contractNumber: string;
  public rowsOnPage = 20;
  public sortBy = '';
  public sortOrder = 'asc';
  public isShowTitle = true;
  private alive = true;

  @Input()
  set contractNum(contractNum: string) {
    this.contractNumber = contractNum;
  }

  constructor(private contactSvc: ContactService,
      private router: Router,
      private route: ActivatedRoute,
      public sanitizer: DomSanitizer) {
        this.route.parent.parent.params
        .takeWhile(() => this.alive)
        .subscribe( params => {
          this.contractNumber = params['id'];
          console.log('Contract Number from YourJSSITeam:' + this.contractNumber);
        });
        if (router.routerState.snapshot.url.indexOf('my-support') > -1) {
          this.isShowTitle = false;
        }
  }

  ngOnChanges(changes: any) {
    this.contractNumber = changes.contractNum.currentValue;
    if (changes.contractNum.currentValue !== changes.contractNum.previousValue) {
        this.getJSSIContact();
    }
  }

  ngOnInit() {
    // Intialize objects
    this.yourContactsTempModel = new ContactDetails();
    this.yourContactsTempModel.Contacts = [];
    this.getContacts();
    this.getJSSIContact();
  }

  getJSSIContact() {
    this.contactSvc.getJSSIContacts(this.contractNumber)
    .takeWhile(() => this.alive)
    .subscribe(
      data => {
                this.yourJssiTeam = data;
            }
    );
  }

  getContacts() {
    this.contactSvc.getContacts(this.contractNumber)
    .takeWhile(() => this.alive)
    .subscribe(
      data => {
                this.yourContactsTempModel = data;
            }
    );
  }

  onUpdateClick(item: Contact) {
    this.router.navigate([`/pages/client/my-contracts/contract/${this.contractNumber}/contacts/edit-contact`],
     { queryParams: { ContactID: item.ContactID,
      AccountID : item.Company.AccountID,
      Role: item.Role}});
  }

  public ngOnDestroy() {
    this.alive = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/yourjssiteam/yourjssiteam.component.ts